import Highcharts from 'highcharts';

export const figure2 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
	marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
        }
         // line: {
        //   stacking: 'normal',
        //   // shared options for all line series
        //
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [ "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px',
          }
        },
      }],
      yAxis: [{
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 200,
        min: 0,
        tickInterval: 50,
        format: '{value.dollar}$',
        gridLineWidth: 2,
        floor: 0,
        title: {
          text: "مليارات",
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
		    },
{ // Secondary yAxis
			    title: {
					   text: '',
					   style: {
							 color: Highcharts.getOptions().colors[1]
						 }
				   },
				   max: 100,
				   min: 0,
				   tickInterval: 20,
				   startOnTick: false,
				   endOnTick: false,
	// plotLines: [{
	//     color: '#d7d7d7',
	//     width: 1,
	//     value: 1000
	// }],
				   offset: 10,
				   gridLineWidth: 0,
				   labels: {
					   format: '{value}',
					   style: {
							   fontWeight: 'normal',
							   color: '#999999',
							   fontSize: '12px'
						   }
				   },
	//title: {
	//    text: 'Millions',
	//    style: {
	//        color: Highcharts.getOptions().colors[1]
	//    }
	//},
				   opposite: true
		    }
	     ],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        // //headerFormat: '<div>{point.key}</div>',
        // valuePrefix: '$',
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
    series: [
      {
	      type: 'column',
	      name: 'خسائر أخرى (بالدولار الأمريكي الحالي)',
	      color: '#fc0002',
	      data: [7.30, 1.17, 10.97, 4.52, 1.61, 1.51, 1.48, 18.17, 13.25, 11.73, 69.47, 85.60, 83.64, 55.12, 44.86, 63.07, 93.45]

      },
      {
            type: 'column',
            name: 'الخسائر الزراعية (بالدولار الأمريكي الحالي)',
            color: '#facabf',
            data: [70.42, 1.30, 1.16, 2.36, 1.83, 1.39, 1.22, 4.65, 4.31, 77.49, 53.30, 71.08, 42.45, 28.00, 41.88, 20.87, 19.62]

        },
        {
            type: 'spline',
            name: 'عدد البلدان المبلغة',
            color: '#a4a4a4',
            dashStyle: 'solid',
            marker: {
                enabled: false
            },
            tooltip: {
              shared: true,
              useHTML: true,
              hideDelay: 500,
              backgroundColor: null,
              borderWidth: 0,
              shadow: false,
              // //headerFormat: '<div>{point.key}</div>',
             valuePrefix: '%',
              style: {
                padding: 0
              }
              },
            data: [22, 18, 24, 23, 23, 25, 23, 24, 30, 27, 48, 58, 71, 61, 53, 42, 22]

        }    ]
}
